// Оптимизация работы с видео
document.addEventListener('DOMContentLoaded', function() {
    const video = document.querySelector('.hero-video');
    const postOverlay = document.getElementById('postVideoOverlay');
    if (!video) return;
    var MOBILE_BREAKPOINT = 768;
    var FADE_BEFORE_END = 4; // секунд до конца
    function isMobileNow() {
        return /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth <= MOBILE_BREAKPOINT;
    }
    // Текущее мобильное состояние
    var mobileMode = isMobileNow();
    function showVideo() {
        video.classList.add('video-ready');
    }
    function showFallback() {
        video.classList.add('video-ready');
    }
    var fadingOut = false;
    function fadeOutVideo() {
        if (fadingOut) return;
        fadingOut = true;
        video.style.transition = 'opacity 1s ease';
        video.style.opacity = '0';
    }
    function showPostVideoOverlay() {
        if (!postOverlay) return;
        postOverlay.classList.add('active');
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                postOverlay.classList.add('visible');
            });
        });
    }
    function hidePostVideoOverlay() {
        if (!postOverlay) return;
        postOverlay.classList.remove('visible', 'active');
    }
    function resetVideo() {
        fadingOut = false;
        video.style.transition = '';
        video.style.opacity = '';
        // Перезапускаем видео если оно уже закончилось
        if (video.ended) {
            video.currentTime = 0;
            video.play().catch(function() {});
        }
    }
    // Показываем видео как только можно начать воспроизведение
    video.addEventListener('canplay', function() {
        video.play().catch(function(error) {
            console.warn('Auto-play prevented:', error);
            showFallback();
        });
        showVideo();
    });
    // Если видео уже готово до DOMContentLoaded (кеш)
    if (video.readyState >= 3) showVideo();
    // Ошибка загрузки — показываем poster/fallback
    video.addEventListener('error', function(e) {
        console.warn('Video loading error:', e);
        showFallback();
    });
    // За 4 секунды до конца: одновременно fade видео и появление overlay (только mobile)
    video.addEventListener('timeupdate', function() {
        if (!mobileMode) return;
        if (video.duration && !fadingOut) {
            var remaining = video.duration - video.currentTime;
            if (remaining <= FADE_BEFORE_END) {
                fadeOutVideo();
                showPostVideoOverlay();
            }
        }
    });
    // Страховка на случай если timeupdate не сработал вовремя; на десктопе — основной триггер
    video.addEventListener('ended', function() {
        if (!fadingOut) fadeOutVideo();
        if (!postOverlay.classList.contains('active')) showPostVideoOverlay();
    });
    // Отслеживание resize — переключение между desktop и mobile поведением
    var resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            var nowMobile = isMobileNow();
            if (nowMobile === mobileMode) return;
            mobileMode = nowMobile;
            if (mobileMode) {
                // Переключились в мобильный режим
                // Если видео уже закончилось — сразу показать overlay
                if (video.ended) {
                    fadeOutVideo();
                    showPostVideoOverlay();
                } else if (video.duration && video.duration - video.currentTime <= FADE_BEFORE_END) {
                    fadeOutVideo();
                    showPostVideoOverlay();
                }
            } else {
                // Переключились в десктопный режим — скрыть overlay, вернуть видео
                hidePostVideoOverlay();
                resetVideo();
            }
        }, 150);
    });
    // Оптимизация для мобильных устройств
    if (/Mobi|Android/i.test(navigator.userAgent)) {
        video.setAttribute('webkit-playsinline', 'true');
        video.setAttribute('x-webkit-airplay', 'allow');
    }
    // Пауза/возобновление при смене вкладки
    document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
            if (!video.paused) {
                video.pause();
                video.setAttribute('data-was-playing', 'true');
            }
        } else if (video.getAttribute('data-was-playing') === 'true') {
            video.play();
            video.removeAttribute('data-was-playing');
        }
    });
});
// Предотвращение контекстного меню на видео
document.addEventListener('contextmenu', function(e) {
    if (e.target.tagName === 'VIDEO') e.preventDefault();
});
// Попап обратной связи
(function() {
    var modal = document.getElementById('contactModal');
    var openBtn = document.getElementById('contactOpenBtn');
    var closeBtn = document.getElementById('contactModalClose');
    var backdrop = document.getElementById('contactModalBackdrop');
    var form = document.getElementById('contactForm');
    var success = document.getElementById('contactSuccess');
    if (!modal || !openBtn) return;
    function openModal() {
        modal.classList.add('open');
        document.body.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus();
    }
    function closeModal() {
        modal.classList.remove('open');
        document.body.style.overflow = '';
    }
    openBtn.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('open')) closeModal();
    });
    if (form) form.addEventListener('submit', function(e) {
        e.preventDefault();
        var data = new FormData(form);
        fetch(form.action, {
            method: 'POST',
            body: data,
            headers: {
                'Accept': 'application/json'
            }
        }).then(function(res) {
            if (res.ok) {
                form.style.display = 'none';
                if (success) success.style.display = 'block';
                setTimeout(closeModal, 2800);
            } else res.json().then(function(data) {
                var msg = (data.errors || []).map(function(e) {
                    return e.message;
                }).join(', ');
                alert('Error: ' + (msg || 'Please try again.'));
            });
        }).catch(function() {
            alert('Network error. Please try again.');
        });
    });
})();

//# sourceMappingURL=mpenny-website.aa1de043.js.map
